import React, {useReducer, useMemo, useRef} from "react";
import "./css/Filing.css";
import {Container, Header} from "@amzn/awsui-components-react/polaris";
import { DOWNLOAD_INITIAL_STATE,downloadReducer,downloadReducerInit} from "../exception/components/common/downloadDocumentReducer";
import Table from "./components/CredentialTable";
import {getParentAndSubUseCase} from "../excalibur/components/fetchAvailableUseCases";
import {formReducer, initialState} from "./utils/credentialManagementReducer";
import CredentialUploadControls from "./components/CredentialUploadControls";


function CredentialManagement(params) {
    const [state, dispatch] = useReducer(formReducer, initialState);
    const {
        useCaseValue,
        selectedSubUseCases,
        selectedCredType,
        certificateExpiryDate,
        uploading,
        status
    } = state;
    // eslint-disable-next-line no-unused-vars
    const [downloadDocument, downloadDocumentDispatcher] = useReducer(downloadReducer, DOWNLOAD_INITIAL_STATE, downloadReducerInit);
    const tableRef = useRef(null);
    
    const UseCaseandSubUseCaseArray = useMemo(() =>
            getParentAndSubUseCase(useCaseValue),
        [useCaseValue]
    );



    const handleUseCaseChange = (e) => {
        dispatch({ type: 'SET_USE_CASE', payload: { useCaseValue: e.detail.id } });
    };

    const handleFileTypeChange = (fileType) => {
        dispatch({ type: 'SET_FILE_TYPE', payload: fileType });
    };

    const handleExpiryDateChange = (date) => {
        dispatch({ type: 'SET_EXPIRY_DATE', payload: date });
    };

    const handleDownloadTemplate = () => {
        // TODO: Implement download template functionality
        const allSelected = selectedSubUseCases.map(s => s.value);
        console.log('Download template for:', allSelected, 'and file type:', selectedCredType);
    };

    const handleUploadComplete = () => {
        // Trigger table refresh by calling the table's refresh method
        if (tableRef.current && tableRef.current.handleRefresh) {
            tableRef.current.handleRefresh();
        }
    };

    return (
        <div className="credentialManagement">
            <Header variant="h1" className="header">Credential Management</Header>
            <Container header={<h2>Upload New Credential</h2>} >
                <Container >
                    1. Select a compliance type to fetch existing credentials.<br/>
                    2. Use our upload template to create your credential file(s). <br/>
                    3. For certificate uploads, choose a folder that contains the certificate files. <br/>
                    4. For credential uploads, select a single file containing the credentials data. <br/>
                </Container>

                <CredentialUploadControls
                    useCaseValue={useCaseValue}
                    selectedCredType={selectedCredType}
                    certificateExpiryDate={certificateExpiryDate}
                    uploading={uploading}
                    status={status}
                    onUseCaseChange={handleUseCaseChange}
                    onFileTypeChange={handleFileTypeChange}
                    onExpiryDateChange={handleExpiryDateChange}
                    onDownloadTemplate={handleDownloadTemplate}
                    onUploadComplete={handleUploadComplete}
                    dispatch={dispatch}
                    domain={params.domain}
                />
            </Container>
            <br />
            <Table
                ref={tableRef}
                {...params}
                downloadDocumentDispatcher={downloadDocumentDispatcher}
                showData={useCaseValue}
                useCase={UseCaseandSubUseCaseArray[0]}
                subUseCase={UseCaseandSubUseCaseArray[1]}
            />
        </div>
    );
}

export default CredentialManagement;